import { TableCopyData } from "./types";

export const initialTableCopyDataState: TableCopyData = {
  copyData: {
    value: "",
    key: "",
    type: "",
  },
  editHistory: [],
};
